import buttoncss from "./../../css/button.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { useState } from "react";


const CONFIG_MODAL_STYLE = { borderRadius: "10px", overflow: "hidden" };


const AddERPConfigModal = ({
  erps,
  handleClose,
  setAddERP,
  erpConfigData,
  company = "",
  companyId = "",
}) => {
  const [selectedERP, setSelectedERP] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [connectionType, setConnectionType] = useState(null);
  const [oAuthUrl, setOAuthUrl] = useState(null);
  const [apiBaseUrl, setApiBaseUrl] = useState(null);
  const [tentId, setTentId] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [grantType, setGrantType] = useState(null);
  const [scope, setScope] = useState(null);

  // ERPNext fields
  const [siteUrl, setSiteUrl] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");
  const [erpNextCompany, setErpNextCompany] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const renderERPForm = () => {
    switch (selectedERP) {
      case "DynamicBC":
        return msbcForm();
      case "tallyPrime":
        return tallyForm();
      case "erpnext":
        return erpNextForm();
      default:
        return null;
    }
  };

  const linkConfigData = () => {
    let erpData;

    if (selectedERP === "erpnext") {
      let normalizedSiteUrl = siteUrl ? siteUrl.trim() : "";
      try {
        if (normalizedSiteUrl) {
          const urlObj = new URL(
            normalizedSiteUrl.startsWith("http://") || normalizedSiteUrl.startsWith("https://")
              ? normalizedSiteUrl
              : `https://${normalizedSiteUrl}`
          );
          normalizedSiteUrl = urlObj.origin;
        }
      } catch (e) {
        // keep input as-is if URL constructor fails
      }

      erpData = {
        erp: "erpnext",
        connection_type: "token",
        companyId: companyId,
        company: company || companyName || "",
        api_url_base_path: normalizedSiteUrl,
        client_id: apiKey ? apiKey.trim() : "",
        client_secret: apiSecret ? apiSecret.trim() : "",
        erp_company: erpNextCompany ? erpNextCompany.trim() : "",
        status: "A",
      };
    } else {
      erpData = {
        erp: selectedERP,
        company: companyName ? companyName : "",
        connection_type: connectionType ? connectionType.value : "",
        OauthUrl: oAuthUrl ? oAuthUrl : "",
        api_url_base_path: apiBaseUrl ? apiBaseUrl : "",
        tentId: tentId ? tentId : "",
        client_id: clientId ? clientId : "",
        client_secret: clientSecret ? clientSecret : "",
        scope: scope ? scope : "",
        grant_type: grantType ? grantType.value : "",
        status: "A",
      };
    }

    erpConfigData(erpData);
  };

  const tallyForm = () => {
    return (
      <>
        <div>
          <InputGroup
            label="Company Name"
            inputs={[
              <>
                <input
                  type="text"
                  placeholder="Enter company name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </>,
            ]}
          />
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="API Base URL"
                  inputs={[
                    <>
                      <textarea
                        value={apiBaseUrl}
                        placeholder="Enter URL"
                        onChange={(e) => setApiBaseUrl(e.target.value)}
                        rows={4}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />
        </div>
      </>
    );
  };

  const msbcForm = () => {
    return (
      <>
        <div>
          <InputGroup
            label="Company Name"
            inputs={[
              <>
                <input
                  type="text"
                  placeholder="Enter Company Name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </>,
            ]}
          />
          <Dropdown
            label="Connection Type"
            options={[{ label: "OAuth", value: "OAuth" }].map(
              (connectiontype) => ({
                label: connectiontype.label,
                value: connectiontype.value,
              })
            )}
            onSelect={(value) => setConnectionType(value)}
            placeHolder={"Select Connection Type"}
          />
          <InputGroup
            label="OAuth URL"
            inputs={[
              <>
                <textarea
                  value={oAuthUrl}
                  placeholder="Enter URL"
                  onChange={(e) => setOAuthUrl(e.target.value)}
                />
              </>,
            ]}
          />
          <InputGroup
            label="API Base URL"
            inputs={[
              <>
                <textarea
                  value={apiBaseUrl}
                  placeholder="Enter URL"
                  onChange={(e) => setApiBaseUrl(e.target.value)}
                  rows={4}
                />
              </>,
            ]}
          />
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Tenent ID"
                  inputs={[
                    <>
                      <input
                        type="text"
                        placeholder="Enter tenent ID"
                        value={tentId}
                        onChange={(e) => setTentId(e.target.value)}
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Client ID"
                  inputs={[
                    <>
                      <input
                        type="text"
                        placeholder="Enter clientID"
                        value={clientId}
                        onChange={(e) => setClientId(e.target.value)}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Client Secret"
                  inputs={[
                    <>
                      <input
                        type="text"
                        placeholder="Enter Client ID"
                        value={clientSecret}
                        onChange={(e) => setClientSecret(e.target.value)}
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Scope"
                  inputs={[
                    <>
                      <input
                        type="text"
                        placeholder="Enter scope"
                        value={scope}
                        onChange={(e) => setScope(e.target.value)}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />
          <Dropdown
            label="Grant Type"
            options={[
              {
                label: "client_credentials",
                value: "client_credentials",
              },
            ].map((connectiontype) => ({
              label: connectiontype.label,
              value: connectiontype.value,
            }))}
            onSelect={(value) => setGrantType(value)}
            placeHolder={" Enter Grant Type"}
          />
        </div>
      </>
    );
  };

  const erpNextForm = () => {
    return (
      <>
        <div>
          <InputGroup
            label="Site URL"
            inputs={[
              <>
                <input
                  type="text"
                  placeholder="e.g. https://your-site.com"
                  value={siteUrl}
                  onChange={(e) => setSiteUrl(e.target.value)}
                />
              </>,
            ]}
          />
          <InputGroup
            label="API Key"
            inputs={[
              <>
                <input
                  type="text"
                  placeholder="Enter API Key"
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                />
              </>,
            ]}
          />
          <InputGroup
            label="API Secret"
            inputs={[
              <>
                <input
                  type="text"
                  placeholder="Enter API Secret"
                  value={apiSecret}
                  onChange={(e) => setApiSecret(e.target.value)}
                />
              </>,
            ]}
          />
          <InputGroup
            label="ERPNext Company"
            inputs={[
              <>
                <input
                  type="text"
                  placeholder="Enter ERPNext Company name"
                  value={erpNextCompany}
                  onChange={(e) => setErpNextCompany(e.target.value)}
                />
              </>,
            ]}
          />
        </div>
      </>
    );
  };

  const addERPModal = () => {
    return (
      <Modal
        title="Add New ERP"
        modalStyle={{
          ...CONFIG_MODAL_STYLE,
          ...(isDropdownOpen ? { minHeight: "370px" } : {}),
          transition: "min-height 0.2s ease",
        }}
        headerActions={
          <CloseIcon
            onClick={() => {
              handleClose();
              setAddERP(false);
            }}
            className="clickable"
          />
        }
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                handleClose();
                setAddERP(false);
              }}
              label="Cancel"
            />
            <Button btnColor={buttoncss.primary} label="Config" />
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        <Dropdown
          label="Select ERP"
          options={erps}
          onSelect={(selected) => {
            setSelectedERP(selected.value);
          }}
          placeHolder={"Select ERP"}
          searchable={true}
          onOpenStateChange={setIsDropdownOpen}
        />
      </Modal>
    );
  };


  const erpConfigModal = () => {
    return (
      <Modal
        title="Configuration"
        width="40%"
        modalStyle={CONFIG_MODAL_STYLE}
        headerActions={
          <CloseIcon
            onClick={() => {
              handleClose();
              setAddERP(false);
            }}
            className="clickable"
          />
        }
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setSelectedERP(null);
              }}
              label="Cancel"
            />
            <Button
              btnColor={buttoncss.primary}
              label="Link ERP"
              onClick={linkConfigData}
            />
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        {renderERPForm()}
      </Modal>
    );
  };

  return (
    <>
      {!selectedERP && addERPModal()}
      {selectedERP && erpConfigModal()}
    </>
  );
};

export default AddERPConfigModal;
